export default "__VITE_PUBLIC_ASSET__d0ca5296__"